<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="card rounded-4">
            <div class="card-body px-4 pt-4 pb-5 text-center">
              <img src="/images/maintenance.png" width="76"/>

              <div class="text-center">
                <h3 class="mt-4 fw-bold">
                  {{ $t('views.pages.maintenance.title') }}
                </h3>

                <div class="text-secondary mt-3 font-16">
                  <div>{{ $t('views.pages.maintenance.maintenance_brief_explanation') }}</div>
                  <div>{{ $t('views.pages.maintenance.back_online_shortly_message') }}</div>
                  <div>{{ $t('views.pages.maintenance.thank_you_for_understanding') }}</div>
                </div>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

import { useRoute } from 'vue-router'

import { useMaintenanceStore } from '@/stores/helpers/maintenance.js'
import { PublicApiClient } from '@/services/PublicApiClient.js'


const route = useRoute()
const maintenanceStore = useMaintenanceStore()
const retryInterval = ref(null)

// Get redirect path from query parameter
const getRedirectPath = () => {
  const redirect = route.query.redirect
  return redirect ? decodeURIComponent(redirect) : '/'
}

// Health check endpoint to verify server status
const checkServerHealth = async () => {
  try {
    await PublicApiClient.get('/up')
    return true
  } catch (error) {
    if (error.response && error.response.status !== 503) {
      return true
    }
    return false
  }
}

// Auto-retry every 30 seconds
const startAutoRetry = () => {
  retryInterval.value = setInterval(async () => {
    const isServerUp = await checkServerHealth()
    if (isServerUp) {
      // Clear maintenance mode state before redirect
      maintenanceStore.setMaintenanceMode(false)
      window.location.href = getRedirectPath()
    }
  }, 30000)
}

onMounted(() => {
  startAutoRetry()
})

onUnmounted(() => {
  if (retryInterval.value) {
    clearInterval(retryInterval.value)
  }
})
</script>